import {i18n, i18nExists} from 'src/i18n';

/** Labels en *ExporterFields se evalúan al importar el módulo; si i18n aún no cargó, quedan como keys. */
function resolveFieldLabel(label) {
  if (typeof label !== 'string') {
    return label;
  }
  if (i18nExists(label)) {
    return i18n(label);
  }
  return label;
}

export default class ExporterSchema {
  fields: Array<any>;
  options: any;

  constructor(fields, options: any = null) {
    this.fields = fields;
    this.options = options;
  }

  get labels() {
    if (this.options?.customLabels) return this.options.customLabels(this.fields);
    return this.fields.map((field) => resolveFieldLabel(field.label));
  }

  labelOf(name) {
    const field = this.fields.find((field) => field.name === name);

    if (field) {
      return resolveFieldLabel(field.label);
    }

    return name;
  }

  cast(row) {
    if (!row) {
      return row;
    }

    const casted = {};

    const castFn =
      this.options?.customCast ||
      (({fields, casted, row}) =>
        (name) => {
          const field = fields.find((field) => field.name === name);
          if (field) {
            casted[name] = field.render ? field.render(row[name]) : row[name] !== undefined ? String(row[name]) : '';
          }
        });
    Object.keys(row).forEach(castFn({fields: this.fields, casted, row}));
    return casted;
  }
}
